import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { emitSearchAction } from "@catchoftheday/analytics";
import { encodeSearchTerm } from "@catchoftheday/utilities";
export function navigateToSearchPage(_x, _x2, _x3) {
  return _navigateToSearchPage.apply(this, arguments);
}

function _navigateToSearchPage() {
  _navigateToSearchPage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(term, inputTerm, sourceType) {
    var encodedSearchTerm, query, params, url;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(!term || term.length == 1)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return");

          case 2:
            encodedSearchTerm = encodeSearchTerm(term);
            query = "/search?query=".concat(encodedSearchTerm);
            params = "&search_src=topbar&ac=0;\n  }".concat(sourceType ? "&st=".concat(sourceType) : "");
            url = "".concat(query).concat(encodeURI(params));
            emitSearchAction({
              user_text: inputTerm,
              is_typehead: term !== inputTerm,
              final_text: term,
              is_special_search: false,
              special_search_details: undefined
            });
            window.location.assign(url);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _navigateToSearchPage.apply(this, arguments);
}